export default function onEnter(e, func: () => void = () => {}) {
  if (e.key === "Enter") {
    func()
  }
}
